module.exports = __webpack_public_path__ + "static/media/HeaderRightArrow.d0fd9665.svg";